import {AfterViewInit, ChangeDetectorRef, Component, HostListener, NgZone, OnInit} from '@angular/core';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { StorageUtil } from 'src/app/utils/storage.util';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit {

  private static readonly WHATSAPP_SUPPORT_PHONE = '5548991250397';
  private static readonly WHATSAPP_SUPPORT_MESSAGE =
    'Olá! Preciso de ajuda com o sistema Easymarine.';

  sidebar = true;
  animate = false;
  dock = true;
  close = false;
  animated = false;

  @HostListener('window:resize', ['$event']) onScroll($event: Event): void {
    this.adjustWidth();
  }

  constructor(private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.adjustWidth();
    // Estado inicial vem da preferência do usuário (EAS-249); o broadcast atualiza nas trocas.
    this.sidebar = this.resolveInitialSidebar();
    BroadcastService.get('showHideSidenav').subscribe(
      (event) => {
        this.sidebar = event;
        if (event) {
          this.animate = true;
          setTimeout(() => {
            this.animate = false;
          }, 1000);
        } else {
          this.close = true;
          setTimeout(() => {
            this.close = false;
          }, 1000);
        }
      }
    );
  }

  // Responsivo: no mobile a barra não fica docada (60px); o estado aberto/recolhido
  // é controlado pelo botão de toggle (broadcast), não mais pela largura nem pelo hover.
  adjustWidth(): void {
    if (window.outerWidth <= 992) {
      this.dock = false;
      this.animated = true;
    } else {
      this.animated = false;
      this.dock = true;
    }
  }

  // Primeiro acesso: aberto (desktop). No mobile inicia recolhido (responsivo).
  private resolveInitialSidebar(): boolean {
    if (window.outerWidth <= 992) {
      return false;
    }
    const pref = StorageUtil.getSidenavOpened();
    return pref ?? true;
  }

  openWhatsappSupport(): void {
    const url = `https://wa.me/${DefaultComponent.WHATSAPP_SUPPORT_PHONE}`
      + `?text=${encodeURIComponent(DefaultComponent.WHATSAPP_SUPPORT_MESSAGE)}`;
    window.open(url, '_blank');
  }
}
